export default __webpack_public_path__ + "static/construction-banner-76d596e77107b4c09cb4eda36b0841bb.jpg";